import { Direction, GameState } from './engine/enums';
import Vector2d from './engine/vector2d';
import Entity from './entity';

import level1 from './levels/level-1.json';

export type EntityInfo = {
  x: number;
  y: number;
  direction: Direction;
  name?: string;
};

export type Level = {
  name: string;
  maze: number[][];
  players: EntityInfo[];
  ghosts: EntityInfo[];
  food: [Food[]];
};

export type Food = { x: number, y: number; isPowerup?: boolean; };

const emptyLevel: Level = {
  name: 'emptyLevel',
  maze: [],
  players: [],
  ghosts: [],
  food: [[]],
};

export default class State {
  public gameTime: number = 0;

  private _gameState: GameState = GameState.Paused;
  public get gameState() {
    return this._gameState;
  }
  public set gameState(value: GameState) {
    this._gameState = value;
  }

  private _level: Level | undefined;
  public get level() {
    return this._level ?? emptyLevel;
  }

  private _currentLevel: number = 1;

  public get map() {
    return this._level?.maze ?? [];
  }

  private _players: Entity[] = [];
  public get players() {
    return this._players;
  }

  private _ghosts: Entity[] = [];
  public get ghosts() {
    return this._ghosts;
  }

  public get displayScore() {
    return 0;
    // const score = this.score.toString();
    // return `${'0000'.substr(0, 4 - score.length)}${score}`;
  }

  private _foodLayer: number = 0;
  public get foodLayer() {
    return this._foodLayer;
  }

  public set foodLayer(value: number) {
    this._foodLayer = value;
  }

  private _food: Food[] = [];
  public get food() {
    return this._food;
  }

  public resetFood() {
    this._food = [...this.level.food[this.foodLayer % this.level.food.length]];
  }

  public set food(value: any) {
    this._food = value;
  }

  public eatFood(position: Vector2d) {
    this._food = this._food.filter(f => !Vector2d.isSame(position, new Vector2d(f.x, f.y)));
    if (this._food.length === 0) {
      this.foodLayer++;
      this.resetFood();
    }
  }

  constructor() {
    (window as any).__state = this;
  }

  reset(): void {
    this.gameTime = 0;
    this.gameState = GameState.Ready;
    this.resetLevel();
    this.resetStage();
  }

  private loadLevel(levelNumber: number) {
    // import level from `./levels/level-${levelNumber}.json`;
    // const level = import
    // const level = require(`./levels/level-${levelNumber}.json`) as Level;
    this._level = level1 as unknown as Level;
  }

  resetLevel(): void {
    this.loadLevel(this._currentLevel);
    this._foodLayer = 0;
    this.resetFood();
    // this._food = this.level.food[this.foodRound];
  }

  resetStage(): void {
    this.resetPlayers();
    this.resetGhosts();
  }

  isGameOver = (): boolean => !this.players.some(p => !p.isDead);

  respawnPlayer(index: number): void {
    const player = this.level.players[index];
    const playerPos = new Vector2d(player.x, player.y);
    this.players[index].position = playerPos;
    this.players[index].target = playerPos;
    this.players[index].direction = player.direction;
    this.players[index].isRespawning = false;
  }

  private resetPlayers(): void {
    this._players = this.level.players.map((p, i) => {
      const pos = new Vector2d(p.x, p.y);
      const player = new Entity(pos, pos, p.direction, `player-${i}`);
      player.lives = 3;
      player.score = 0;

      return player;
    });
  }

  private resetGhosts(): void {
    this._ghosts = this.level.ghosts.map(g => {
      const pos = new Vector2d(g.x, g.y);
      const ghost = new Entity(pos, pos, g.direction, g.name);
      ghost.lives = 1;
      return ghost;
    });
  }

  updateMap(pos: Vector2d, tile: number): void {
    this.map[pos.y][pos.x] = tile;
  }

}